// extracted by mini-css-extract-plugin
export default {"image":"MobileTopBar_image__7H1kA","bannerContainer":"MobileTopBar_bannerContainer__lDiW9","bannerImage":"MobileTopBar_bannerImage__KM8yR"};